export default "__VITE_ASSET__CzgiIDsb__"